import isEmpty from 'lodash/isEmpty'
import createReducer from '../../../common/redux/createReducer'

export default createReducer(
  {
    isAuthenticated: false,
    user: {},
  },
  {
    SET_CURRENT_USER: (state, action) => ({
      isAuthenticated: !isEmpty(action.user),
      user: action.user,
    }),
  }
)
